import { render } from "./SmartHRIcon.vue?vue&type=template&id=00f5a8d7"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__